export function isNativeMiloraApp(): boolean {
  if (typeof window === 'undefined') return false;
  return Boolean(window.ReactNativeWebView) || navigator.userAgent.includes('MiloraApp');
}

export function parseNativeDeepLinkPath(urlOrPath: unknown, pathField?: unknown): string | null {
  if (typeof urlOrPath === 'string' && urlOrPath.startsWith('/')) {
    return urlOrPath;
  }

  if (typeof pathField === 'string') {
    if (pathField.startsWith('/')) return pathField;
    if (pathField.length > 0) return `/${pathField}`;
  }

  if (typeof urlOrPath !== 'string' || !urlOrPath.includes('://')) {
    return null;
  }

  const withoutScheme = urlOrPath.replace(/^[^:]+:\/\//, '');
  const slashIndex = withoutScheme.indexOf('/');
  if (slashIndex === -1) return '/';

  return withoutScheme.slice(slashIndex);
}
